export const discussionTypes = [
 'all',
 'signing',
 'teamnews',
 'player',
 'challengecup'
];
